import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { CertificateResource } from "@/types/certificateTypes"

export const useCertificates = () => {
  return useGenericQuery<CertificateResource[]>({
    keys: QUERY_KEYS.certificates.index(),
    apiEndpoint: ENDPOINTS.certificates.index(),
  })
}

export const usePublicCertificate = (uuid: string) => {
  return useGenericQuery<CertificateResource>({
    keys: QUERY_KEYS.certificates.show(uuid),
    apiEndpoint: ENDPOINTS.certificates.show(uuid),
  })
}
